var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM9 3.5C9.5525 3.5 10 3.9475 10 4.5C10 5.0525 9.5525 5.5 9 5.5C8.4475 5.5 8 5.0525 8 4.5C8 3.9475 8.4475 3.5 9 3.5ZM9.8815 12.023C8.972 12.381 8.7065 12.5 8.1225 12.5C7.6455 12.5 7.2745 12.3835 7.01 12.151C6.4875 11.691 6.5755 11.027 6.739 10.347L7.231 8.6055C7.326 8.247 7.5185 7.5145 7.249 7.2575C6.9795 7.0005 6.352 7.163 5.987 7.299L6.1185 6.7625C6.6455 6.548 7.3115 6.2855 7.88 6.2855C8.735 6.2855 9.3605 6.713 9.3605 7.52C9.3605 7.5955 9.3515 7.7285 9.334 7.9195C9.301 8.27 9.291 8.247 8.745 10.18C8.684 10.3925 8.5895 10.844 8.5895 11.0625C8.5895 11.904 9.568 11.696 10.013 11.486L9.8815 12.023Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.99f88200.svg";
export { ForwardRef as ReactComponent };